export default __webpack_public_path__ + "10c838ab6e7399e75d0c84865c564b8a.svg";